import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { AuditRequestGrid } from "../audit-request-grid/AuditRequestGrid";
import { auditAPI } from "../../../api/auditAPI/auditAPI";

const AuditContainer = (props) => {
  const [filter, setFilter] = React.useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [data, setDataGrid] = useState([]);
  const [audit, setAudit] = useState([]);
  useEffect(async () => {
    const response = await auditAPI.getallAudit();
    if (response.status !== 200) {
    } else {
      const newData = response.data;
      setDataGrid(newData);
      setAudit(newData);
    }
  }, []);

  const handleChange = React.useCallback(
    (e) => {
      if (e?.target?.value !== undefined) setFilter(e.target.value);
    },
    [setFilter]
  );

  const filterAuditByPhoneOrEmail = async () => {
    if (filter !== undefined && filter !== "") {
      var newData = data.filter((x) => {
        if (x.link === filter || x.actionType !== 2) return x;
      });

      setAudit(newData);
    }
  };

  const removeFilter = async () => {
    const newData = [...data];
    setAudit(newData);
  };

  return (
    <>
      <div className="Audit-page">
        <div className="row">
          <div className="col-xxl-6 Audit-title">Audit</div>
        </div>
        <div className="row justify-content-md-center">
          <AuditRequestGrid dataGrid={audit} userPreFilter="Username" />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = function(state) {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export const Audit = connect(
  mapStateToProps,
  mapDispatchToProps
)(AuditContainer);
